<template>
  <div class="content">
    <label class="text-value">{{ component.label }}</label>
  </div>
</template>
<script>
export default {
  name: 'TextValue',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style scoped>
.content {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.text-value {
  font-weight: bold;
  font-size: 14px;
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 5px;
}
</style>
